import { useCallback, useEffect, useRef } from 'react';
import { Virtualizer } from '@tanstack/react-virtual';
import { useAdditionalInfos } from '../hooks/use-additional-infos/use-additional-infos';

export const useUpdateVisibleAsRead = (
    enabled: boolean,
    virtualizer: Virtualizer<HTMLDivElement, Element>
): void => {
    const { list: data, hasUnread, markAsRead } = useAdditionalInfos();

    const running = useRef(false);
    const virtualItems = virtualizer.getVirtualItems();
    const readInfos = useCallback(() => {
        // Don't run if disabled or currently running.
        if (!enabled || running.current) return;
        // Don't run without both unreadInfos and virtualItems
        if (!hasUnread) return;
        if (!Array.isArray(virtualItems) || virtualItems.length === 0) return;
        // Start running, get the visible infos.
        running.current = true;
        const visibleInfos = data.slice(
            virtualItems[0].index,
            virtualItems[virtualItems.length - 1].index + 1
        );
        // Mark them as read, don't block the next run.
        markAsRead(visibleInfos).finally(() => {
            running.current = false;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [virtualItems, data, enabled, running, hasUnread]);

    useEffect(() => {
        readInfos();
    }, [readInfos]);
};
